<div class="container">
    <div class="header">
        <div class="title-text-container">
            <div fiTranslation="REQUEST_DETAIL_HEADER_MENU_OFFER_ORDER"></div>
        </div>

        <fi-button
          variant="tertiary"
          tone="neutral"
          size="lg"
          [iconOnly]="true"
          (click)="onClosePopup()"
        >
          <mat-icon fiButtonIcon>close</mat-icon>
          <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
        </fi-button>
    </div>

    <div class="main-content">
        <fi-order-offer
                [isMobile]="isMobile"
                [isClosed]="isClosed"
                [actions]="actions"
                [leadId]="leadId"
                [onAction]="onAction"
                [selectedLeadHistory]="selectedLeadHistory"
                [composerOrders]="composerOrders"
                [composerOffers]="composerOffers"
                [isActive]="!limitedAccess"
                (overlayClosed)="overlayClosed($event)"
                (loadComposerOffers)="loadComposerOffersToParent($event)"
                class="header-action-item">
        </fi-order-offer>
    </div>
</div>




